<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M10 18.3334C14.6024 18.3334 18.3333 14.6025 18.3333 10.0001C18.3333 5.39771 14.6024 1.66675 10 1.66675C5.39763 1.66675 1.66667 5.39771 1.66667 10.0001C1.66667 14.6025 5.39763 18.3334 10 18.3334Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10 6.6665V9.99984"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M10 13.3335H10.0078"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconAlertCircle',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
